import React, { useEffect, useState } from 'react'
import { Constants } from '../../CommonMethhods/Constants'
import { toast } from 'react-toastify'
import { AESEncryption, ApiResDecrypt, noDataFound, onlyNumber } from '../../CommonMethhods/CommonMethods';
import searchIcon from "../../asset/images/search-icon.svg"
import SmallLoader from '../../Components/Common/smallLoader';
import downloadbrokrage from '../../asset/images/download-brokrage.svg';
import Loader from '../../Components/Common/Loader';
import AttachmentFile from "../../asset/images/uploadColored.svg";
import axios from 'axios';
import { CLIENT_FNO } from '../../Configuration/API_URL';
import { useDebounce } from '../../Components/useDebounce';
import disableUpload from "../../asset/images/upload-disable.svg"
import LoaderForSearch from '../../Components/Common/LoaderForSearch';

export default function ClientFnoLossTable(props) {
    let gridVal = props.gridVal
    const [image, setImage] = useState();
    const [uploadedFiles, setUploadedFiles] = useState({})
    const [actionVal, setActionVal] = useState({});
    const [searchInput, setSearchInput] = useState("");
    const [searchField, setSerchField] = useState(false);
    const storeToken = localStorage.getItem("ssoToken");
    const [action, setAction] = useState("")
    const projectRole = JSON.parse(localStorage.getItem("project"));
    const value = projectRole.filter(item => item?.Name === "Cosmos");
    const valueAdmin = value.filter(item => item.Role.Name === "Admin")
    const getRole = valueAdmin[0]?.Role?.Name;
    const debouncedValue = useDebounce(searchInput, 1000);

    useEffect(() => {
        handleSearchChange(debouncedValue);
    }, [debouncedValue]);

    const handleScroll = (e) => {
        const a = e.target;
        if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight) {
            if (props.count != gridVal.length) {
                props.setPageTable((prev) => prev + 1);
                props.setScrollLoaderTable(true);
                props.setLoader(false);
                let offset = props.pageTable + 1
                props.getClientFno("grid", searchInput, 5, offset)
            }
            else {
                props.setScrollLoaderTable(false);
            }
        }
    };
    const handleAction = (val, id) => {
        setAction(val)
        setActionVal(prevState => ({
            ...prevState,
            [id]: val
        }));
    }
  
    const handleSubmitDoc = (item, status) => {
        updateDocument(item, status)
    }
    const updateDocument = async (item, status) => {
        const formData = new FormData();
        formData.append("File", image);
        formData.append("Status", status);
        formData.append("Id", item?.id)

        try {
            const getRemark = await axios.post(
                CLIENT_FNO.Update_Document,
                formData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${storeToken}`,
                        // reserv: 1,
                    },
                }
            );

            const res = (getRemark?.data);
            if (res?.status === 0) {
                props.setPageTable("1")
                props.getClientFno("grid", searchInput, 5, 1);
                setImage("")
                setUploadedFiles("")
                toast.success(res?.data);
                setAction("")
                setActionVal("")

            }
        } catch (error) {
            if (error?.request?.status == 401) {
                localStorage.clear("");
                // navigate("/");
            }
        }
    };
    const handleFileUpload = (e, index) => {
        if (e?.target?.files && e?.target?.files?.length > 0) {
            let file = e.target.files[0]
            if (e?.target?.files[0]) {
                const allowedTypes = ["application/pdf"];
                if (allowedTypes.includes(file.type)) {
                    let size = Math.round((e?.target?.files[0]?.size / 1024))
                    let fileExtension = e?.target?.files[0]?.name.split('.')

                    if (e?.target?.files[0]?.type && (fileExtension?.length > 2 || fileExtension?.length === 2) &&
                        !(e?.target?.files[0]?.type === 'application/pdf')) {
                        toast.error("File size limit is 5 mb and in  pdf format")
                    } else if (fileExtension[1] !== "pdf") {
                        toast.error("Invalid image name")
                    }
                    else if (size > 5120) {
                        toast.error("File size limit is 5 mb and in pdf format")
                    }
                    else {
                        setImage(e?.target?.files[0])

                        const file = e.target.files[0];
                        if (file) {
                            setUploadedFiles(
                                { [index]: file.name }
                            );
                        }
                    }
                }
                else {
                    toast.error("File size limit is 5 mb and in pdf format")
                }
            }
            
        }
    };

    const handleSearchChange = (data) => {
        if (data) {
            props.getClientFno("grid", data, 5, 1);
        }
        else if (searchField === true) {
            props.getClientFno("grid", "", 5, 1);
            //
        }
        props.setPageTable(1)

    };
    const onDownloadDoc = async (id) => {

        let payloadValue = {
            id: id
        };
        let encPayload = AESEncryption(payloadValue);
        try {
            const getRemark = await axios.post(
                CLIENT_FNO.Download_Doc,
                `"${encPayload}"`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${storeToken}`,
                        reserv: 1,
                    },
                }
            );

            const res = ApiResDecrypt(getRemark?.data);
            if (res?.status === 0) {
                window.open(
                    res?.data,
                    "_blank",
                    "noopener,noreferrer"
                );

            }
        } catch (error) {
            if (error?.request?.status == 401) {
                localStorage.clear("");
                // navigate("/");
            }
        }

    }
    
    return (
        <>
            <div className='personal-page brokerage'>
                <div className='personal-wrapper'>
                    <div className='search-input-wrapper'>
                        <div className="rm-custom-dropdown">
                            <img src={searchIcon} alt="search" />

                            <input
                                type="text"
                                name="search-text"
                                className="input-st ap"
                                maxLength={20}
                                // onInput={onlyNumber}
                                value={searchInput}
                                placeholder="Search by RM code"
                                autoComplete="off"
                                onChange={(e) => {
                                    setSearchInput(e?.target?.value?.toUpperCase());
                                    setSerchField(true)
                                }}
                            />

                        </div>

                        <button className="dnload-btn" onClick={() => { props.getClientFno("excel", searchInput, -1, -1) }}>
                            {props.smallLoaderExcel ? (
                                <SmallLoader />
                            ) :
                                <>
                                    <img src={downloadbrokrage} alt="download" />
                                    Download All</>
                            }
                        </button>
                    </div>
                </div>

                <div className='brokerage-table'>
                    {props.loader ? (
                        <Loader />
                    ) :
                        <div className="scroll-table master_table personalised-table general-table">
                            {gridVal && gridVal?.length > 0 ? (
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>
                                                <span className='wrap-th'>
                                                    <span>Sr. No</span>
                                                </span>
                                            </th>
                                            <th>
                                                <span className='wrap-th'>
                                                    <span>RM Code</span>

                                                </span>
                                            </th>
                                            <th>
                                                <span className='wrap-th'>
                                                    <span>Client Code</span>

                                                </span>
                                            </th>
                                            <th>
                                                <span className='wrap-th'>
                                                    <span>Month</span>

                                                </span>
                                            </th>
                                            <th>
                                                <span className='wrap-th'>
                                                    <span>F&O Loss Percentage</span>
                                                </span>
                                            </th>

                                            <th>
                                                <span className='wrap-th'>
                                                    <span>Status</span>
                                                </span>
                                            </th>
                                            <th>
                                                <span className='wrap-th'>
                                                    <span>Ledger Documents</span>
                                                </span>
                                            </th>
                                            {getRole == "Admin" ? <th>
                                                <span className='wrap-th'>
                                                    <span>Actions</span>
                                                </span>
                                            </th>
                                                :
                                                <th>
                                                    <span className='wrap-th'>
                                                        <span>Upload Ledger</span>
                                                    </span>
                                                </th>
                                            }

                                            <th>
                                                <span className='wrap-th'>
                                                    <span>Confirm Action</span>
                                                </span>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody onScroll={(e) => handleScroll(e)} id="per-table-body">
                                        {gridVal?.length > 0 && gridVal.map((item, index) => (
                                            <tr key={index}>
                                                <td><span>{index + 1}</span></td>
                                                <td><span>{item?.rmCode}</span></td>
                                                <td><span>{item?.clientCode}</span></td>
                                                <td><span>{item?.month}</span></td>
                                                <td><span>{item?.fnolossPerc}%</span></td>
                                                <td>
                                                    <div className={`status-label ${item?.status === 'Pending' ? 'text-yellow' :
                                                        item?.status === 'Approved' ? 'text-green bg-light-green-new' : item?.status === 'Submitted' ? "text-blue-dark bg-light-blue" : 'txt-red bg-light-red-new'}`}>
                                                        {item?.status}
                                                    </div>
                                                </td>

                                                {getRole == "Admin" ?
                                                    <>
                                                        <td className='text-blue-dark' style={{ cursor: "pointer" }}>
                                                            <div className='d-flex align-items-center'>
                                                                <div
                                                                    onClick={() => {
                                                                        // window.open(
                                                                        //     item?.ledgerDoc,
                                                                        //     "_blank",
                                                                        //     "noopener,noreferrer"
                                                                        // );
                                                                        onDownloadDoc(item?.id)
                                                                    }}
                                                                    className={item?.ledgerDoc ? "tagAnchor" : ""}
                                                                >
                                                                    {item?.ledgerDoc ? item?.ledgerDoc : ""}
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className='action-wrapper'>
                                                                <button
                                                                    className={`${(actionVal[item?.id] === "Approved" || item?.status == "Approved") ?
                                                                        "text-white bg-green status-label no-drop-cursor" :
                                                                        item?.status === "Rejected" ? "disabled-text-approve status-label no-drop-cursor" :
                                                                            "disabled-text-approve status-label"}`}
                                                                    type='button'
                                                                    onClick={() => handleAction("Approved", item?.id)}
                                                                >
                                                                    Approve
                                                                </button>

                                                                <button
                                                                    className={`${actionVal[item?.id] === "Rejected" || item?.status === "Rejected" ?
                                                                        "text-white bg-red status-label no-drop-cursor" :
                                                                        item?.status === "Approved" ? "disabled-text-reject status-label no-drop-cursor" :
                                                                            "disabled-text-reject status-label"}`}
                                                                    type='button'
                                                                    onClick={() => handleAction("Rejected", item?.id)}
                                                                >
                                                                    Reject
                                                                </button>
                                                            </div>
                                                        </td>


                                                        <td>
                                                            <button
                                                                type="button"
                                                                className="submit-buttons"
                                                                onClick={() => handleSubmitDoc(item, action)}
                                                                // disabled={(item?.status === "Pending" && actionVal[item?.id] !== "Approved")
                                                                //     || item?.status === "Rejected" || item?.status === "Approved"}
                                                                disabled={!(actionVal[item?.id] === "Approved" || actionVal[item?.id] === "Rejected")}
                                                            >
                                                                Submit
                                                            </button>
                                                        </td>
                                                    </> :
                                                    <>
                                                        <td className='text-blue-dark' style={{ cursor: "pointer" }}>
                                                            <div className='d-flex align-items-center'>
                                                                <div
                                                                    onClick={() => {
                                                                        // window.open(
                                                                        //     item?.ledgerDoc,
                                                                        //     "_blank",
                                                                        //     "noopener,noreferrer"
                                                                        // );
                                                                        onDownloadDoc(item?.id)
                                                                    }}
                                                                    className={item?.ledgerDoc ? `tagAnchor` : ""}
                                                                >
                                                                    {item?.ledgerDoc ? item?.ledgerDoc : "-"}
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="custom-upload" >
                                                                <div className={`fileUpload btn btn--browse upload-doc ${item?.status === "Submitted" || item?.status === "Approved" ? "disabled" : ""}`}>
                                                                    {item?.status === "Submitted" || item?.status === "Approved" ?
                                                                        <img
                                                                            src={disableUpload}
                                                                            alt="attachment"
                                                                            className
                                                                        />
                                                                        :
                                                                        <img
                                                                            src={AttachmentFile}
                                                                            alt="attachment"
                                                                            className
                                                                        />
                                                                    }
                                                                    <span>Upload File</span>
                                                                    <input
                                                                        type="file"
                                                                        id="clientfno"
                                                                        className="upload"
                                                                        name='files'
                                                                        accept=".pdf"
                                                                        key={image?.name || ""}
                                                                        disabled={
                                                                            item?.status === "Submitted" || item?.status === "Approved"}
                                                                        onChange={(e) => { handleFileUpload(e, index) }}

                                                                    />
                                                                </div>
                                                                <div className='text-blue-dark d-flex align-items-center text-wrapper'><span title={`${uploadedFiles[index] || ""}`} style={{ fontSize: "12px", fontFamily: "Rubik", whiteSpace: "nowrap" }}>{uploadedFiles[index] || ""}</span></div>

                                                            </div>
                                                        </td>
                                                        <td>
                                                            <button
                                                                type="button"
                                                                className={`submit-buttons ${item?.status === "Submitted" || item?.status === "Approved" ? "disabled" : ""}`}
                                                                onClick={() => handleSubmitDoc(item, "Submitted")}

                                                                disabled={
                                                                    item?.status === "Submitted" || item?.status === "Approved"}
                                                            >
                                                                <span>Submit</span>
                                                            </button>
                                                        </td>
                                                    </>}
                                            </tr>
                                        ))
                                        }
                                        {props.scrollLoaderTable && (
                                            <div className="loader-center">
                                                <LoaderForSearch />
                                            </div>
                                        )}
                                    </tbody>
                                </table>
                            ) : noDataFound()
                            }
                        </div>
                    }
                </div>
            </div>
        </>
    )
}
